import { connect } from "react-redux";

import CitiesSection from "../../components/sections/cities_section";

const mapStateToProps = (state) => {
  const isLoading = state.main.loading.tabIsLoading;
  const anyCitiesSelected = state.main.filters.cities.selectedValues.length > 0;

  return { isLoading, anyCitiesSelected };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CitiesSection);
